// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[name=\"profile\"] {\n  width: 15px;\n  height: 15px;\n}\ninput[name=\"profile\"] {\n  accent-color: #ff712d;\n}\n", ""]);
// Exports
module.exports = exports;
